import eventsService from "../services/eventsService";

export const OFFLINE_FACILITATOR_CAPTURE_QUEUE_KEY = "seims.offline.facilitator.capture";
export const OFFLINE_INDIVIDUAL_CAPTURE_QUEUE_KEY = "seims.offline.individual.capture";
export   const OFFLINE_GROUP_CAPTURE_QUEUE_KEY = "seims.offline.group.capture";

const commonConfig = {
    retry: {
      maxAttempts: 5,
    },
    throttleMs: 150,
}
export const queueConfig = {
  [OFFLINE_INDIVIDUAL_CAPTURE_QUEUE_KEY]: {
    mutation: (transaction) => eventsService.addIndividualParticipant(transaction),
    label: "Individual Capture",
    notifications: {
      success: (count) =>
        `${count} queued Individual Capture${count > 1 ? "s" : ""} synced successfully`,

      error: (count) =>
        `${count} queued Individual Capture${count > 1 ? "s" : ""} failed to sync`,
    },
    ...commonConfig
  },

  [OFFLINE_GROUP_CAPTURE_QUEUE_KEY]: {
    mutation: (transaction) => eventsService.addGroupParticipant(transaction),
    label: "Group Capture",
    notifications: {
      success: (count) => `${count} group captures synced`,
      error: (count) => `${count} group captures failed`,
    },
    ...commonConfig
  },

    [OFFLINE_FACILITATOR_CAPTURE_QUEUE_KEY]: {
    mutation: async (transaction) => {
      return Promise.all([
        eventsService.addScienceFacilitator(transaction),
        eventsService.addIndividualParticipant(transaction),
      ]);
    },
        label: "Science Faciliator Capture",
    notifications: {
      success: (count) => `${count} group captures synced`,
      error: (count) => `${count} group captures failed`,
    },
    ...commonConfig
  },
};

export const validateQueueConfig = () => {
  Object.entries(queueConfig).forEach(([key, config]) => {
    if (typeof config.mutation !== "function") {
      throw new TypeError(`Invalid queueConfig: ${key} missing mutation`);
    }
  });
};
